import React, { Component } from 'react';
import {Icon} from 'antd-mobile';
class shopList extends Component {
    constructor(props) {
        super(props);
    }
    openModal21 = (storeInfo)=>{
        this.props.openModal21(storeInfo);
    };
    storeDetail = (e)=>{
        const storeId = e.currentTarget.getAttribute("data-name");
        this.props.storeDetail(storeId);
    };
    render() {
        const { storeList } = this.props;
        return (<div id="card"><div className="card h-shadow mt20" style={{display:storeList.length > 0 ? 'block': 'none'}}>
                {storeList.map((item,index)=>{
                return <div key={ index.toString() } className="store-item">
                        <div className="store-info">
                            <div
                                onClick={() => this.openModal21({...item})}
                                index={index}
                            >
                                <div className="store-title"><span>{item.storeName}</span><img className="store-img" src="/assets/StoreSelection_Store.png" /></div>
                                <span className="store-address">{item.address}</span>
                                <div className="time">{item.businessHours}</div>
                            </div>
                        </div>
                        <div onClick={this.storeDetail} data-name={item.storeId} className="store-detail"><Icon type="right" size="lg" color="#a8a8a8"/></div>
                    </div>
                })}
        </div></div>)
    }
}

export default shopList;